import React from 'react'
import './styles.scss'
import Profile from '../profile'
import Scrollchor from 'react-scrollchor'

export default class chart extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isExpanded: false
    }
    this.toggleMore = this.toggleMore.bind(this)
    this.trackMoreClick = this.trackMoreClick.bind(this)
    this.trackLessClick = this.trackLessClick.bind(this)
  }

  // trackMoreClick (targetLink) {
  //   // GA tracking
  //   let clickedPerson = targetLink.getAttribute('data-person')
  //   console.log('person:' + clickedPerson)
  //   window.dataLayer = window.dataLayer || []
  //   window.dataLayer.push({
  //     event: 'Interactions',
  //     event_action: 'click',
  //     event_label: 'Porträt: ' + clickedPerson
  //   })
  // }

  trackMoreClick(target) {
    let clickedText = target
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'Toggle: ' + clickedText
    })
  }

  trackLessClick(target) {
    let clickedText = target
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'Toggle: ' + clickedText
    })
  }

  toggleMore() {
    if (this.state.isExpanded) {
      this.setState({
        isExpanded: false,
        fade: false
      })
    } else {
      // GA tracking
      // let clickedPerson = e.currentTarget.getAttribute('data-person')
      // console.log('person:' + clickedPerson)
      // window.dataLayer = window.dataLayer || []
      // window.dataLayer.push({
      //   event: 'Interactions',
      //   event_action: 'click',
      //   event_label: 'Porträt: ' + clickedPerson
      // })
      this.setState({
        isExpanded: true,
        fade: true
      })
    }
  }

  render() {
    return (
      <div className='chart-wrapper'>
        <div
          className={
            this.state.isExpanded
              ? 'chart-info expanded'
              : 'chart-info collapsed'
          }
        >
          <div className='intro-text'>
            <p>
              Cette liste défie l’entendement. Six Bugatti, neuf Ferrari,
              quatre Lamborghini, des «hypercars» de marques Koenigsegg ou
              Pagani… Le 5 juillet 2018, un tribunal genevois a ordonné le
              séquestre de ces <span className='money box'>61 bolides</span> de
              superluxe. Une collection quasiment unique par son extravagance et
              son prix - plus de{' '}
              <span className='money box'>45 millions de francs</span>.
            </p>
            <p>
              Le propriétaire des voitures, le financier émirati Khadem
              Al-Qubaisi, est un ancien président de la banque privée zurichoise
              Falcon. La justice suisse enquête contre lui pour gestion déloyale
              et blanchiment, entre autres. Un fonds souverain d’Abu Dhabi,
              qu’il dirigeait, lui réclame aujourd’hui 171 millions de francs et
              a fait saisir sa collection de voitures par le tribunal civil de
              Genève.
            </p>
            <p>
              Mais seuls 11 de ses véhicules ont été retrouvés en Suisse, les
              moins chers. Ils ne valent «que» 2,17 millions de francs. Alors,
              où sont passés les 50 bolides restants?
            </p>
            <p>
              Une partie de la collection s’est évaporée dans des pays
              étrangers. Pour tenter de la retrouver, la cellule enquête de
              Tamedia a dressé une liste exhaustive des véhicules concernés, en
              se basant sur leurs numéros de plaques helvétiques{' '}
              <span>
                <Scrollchor to='#methodik' animate={{ offset: -15 }}>
                  (
                  <i className='small double angle down icon' />
                  En savoir plus sur la méthodologie )
                </Scrollchor>
                .
              </span>
            </p>
            <p>
              Avez-vous vu ces véhicules, éventuellement avec leurs plaques
              genevoises? Dans ce cas, n’hésitez pas à nous contacter:{' '}
              <a href='mailto:cellule-enquete@tamedia.ch?subject=voitures-superluxe'>
                cellule-enquete@tamedia.ch
              </a>
            </p>
            <p
              className={this.state.fade ? 'notDisplay' : 'fade'}
              id='mehrLesen'
            >
              Khadem al-Qubaisi est accusé de s’être enrichi frauduleusement
              alors qu’il dirigeait un fonds souverain d’Abu Dhabi, IPIC, entre
              2007 et 2015. Il aurait notamment poussé le fonds à investir dans
              la banque italienne UniCredit, dont il détenait secrètement des
              actions.
            </p>
          </div>
          <div className='show-more'>
            <botton
              className='ui button toggleText'
              onClick={() => {
                this.toggleMore()
                this.trackMoreClick('mehrLesen')
              }}
              data-person={this.props.trackingID}
            >
              en savoir plus <i className='chevron right icon small' />
            </botton>
          </div>
          <div className='additional-text'>
            <p>
              Khadem al-Qubaisi est accusé de s’être enrichi frauduleusement
              alors qu’il dirigeait un fonds souverain d’Abu Dhabi, IPIC, entre
              2007 et 2015. Il aurait notamment poussé le fonds à investir dans
              la banque italienne UniCredit, dont il détenait secrètement des
              actions. C’est dans ce volet qu’il vient d’être condamné à 15 ans
              de prison aux Emirats. Et que le fonds souverain d’Abu Dhabi a
              obtenu le séquestre de sa collection de voitures à Genève.
            </p>
            <p>
              Un avocat du fonds souverain, Marc Hassberger, confirme avoir
              «entrepris diverses actions judiciaires» contre Khadem Al-Qubaisi
              - dont la saisie des voitures. L’ordonnance de séquestre du
              tribunal civil genevois, datée du 5 juillet 2018, est le document
              qui nous a permis de reconstituer sa collection.
            </p>
            <p>
              Le Ministère public de la Confédération (MPC) confirme qu’il a
              aussi ouvert une procédure pénale dans le dossier UniCredit.
              L’enquête est notamment dirigée contre Khadem al-Qubaisi, pour
              lequel «la présomption d’innocence prévaut», précise le MPC. Début
              2019, depuis sa prison, le financier avait{' '}
              <a href='https://www.wsj.com/articles/alleged-1mdb-conspirator-says-he-is-a-scapegoat-for-emiratis-11548239402'>
                <i className='icon external alternate' />
                affirmé au Wall Street journal
              </a>{' '}
              qu’il avait agi au service des plus hautes autorités des Emirats
              et qu’il servait de bouc émissaire dans cette affaire. Ses avocats
              genevois n’ont pas voulu s’exprimer.
            </p>
            <p>
              Selon nos informations, le MPC a fait bloquer une partie de la
              collection de voitures du financier émirati dans un garage de luxe
              près de Munich. Une demande d’entraide a été adressée en ce sens
              par la Suisse, confirme le Ministère public de la capitale
              bavaroise. Mais le garagiste refuserait de restituer les
              véhicules. Il n’a pas réagi à nos questions. Le MPC a simplement
              indiqué avoir transmis deux demandes d’entraide à l’Allemagne pour
              saisir des actifs, dont l’une serait toujours en cours.
            </p>

            <Profile
              avatarSrc={require('../profile/img/kopf_qubaisi.jpg')}
              name='Khadem Al-Qubaisi'
              byline='Citoyen des Émirats arabes unis'
            />

            <div className='box'>
              <div className='partTwo'>
                <p>
                  Né en 1971, <span className='bold'>Khadem al-Qubaisi </span>
                  est un protagoniste clé du plus grand scandale financier des
                  dernières années. Des dirigeants du fonds malaisien 1MDB sont
                  accusés d’avoir détourné quelque 4,5 milliards de dollars,
                  notamment au profit de l’ancien premier ministre malaisien et
                  de sa famille. Khadem al-Qubaisi aurait empoché plus de 472
                  millions de dollars pour avoir offert la garantie du fonds
                  souverain d’Abu Dhabi, IPIC, à certaines transactions de 1MDB.
                  La justice suisse enquête sur l’affaire depuis quatre ans:
                  elle affirme avoir bloqué 400 millions de dollars dans
                  différentes banques. Selon le Ministère public de la
                  Confédération, quelque 6 milliards de francs de flux suspects
                  liés à l’affaire 1MDB auraient transité par la Suisse.
                </p>
              </div>
            </div>
          </div>

          <div className='show-less'>
            <a
              href='#mehrLesen'
              className='ui button toggleText'
              onClick={() => {
                this.toggleMore()
                this.trackLessClick('weniger')
              }}
              animate={{ offset: -15 }}
            >
              moins <i className='chevron up icon small' />
            </a>
          </div>
        </div>
      </div>
    )
  }
}
